function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.Sitemap0{fill:none;stroke:#16224A;stroke-width:2;stroke-miterlimit:10;}\n\t.Sitemap1{fill:#FFBE54;stroke:#16224A;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Sitemap-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sitemap_01_",
  transform: "translate(1.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_4_",
  className: "Sitemap0",
  d: "M8.5,39.5v-9c0-1.1,0.9-2,2-2h42c1.1,0,2,0.9,2,2v9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_5_",
  className: "Sitemap0",
  d: "M31.5,18.8v20.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_6_",
  className: "Sitemap1",
  d: "M16.5,53.6c0,1.1-0.9,2-2,2h-12c-1.1,0-2-0.9-2-2v-12c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2V53.6 L16.5,53.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_1_",
  className: "Sitemap1",
  d: "M39.5,53.6c0,1.1-0.9,2-2,2h-12c-1.1,0-2-0.9-2-2v-12c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2 V53.6L39.5,53.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_2_",
  className: "Sitemap1",
  d: "M62.5,53.6c0,1.1-0.9,2-2,2h-12c-1.1,0-2-0.9-2-2v-12c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2 V53.6L62.5,53.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Sitemap_3_",
  className: "Sitemap1",
  d: "M39.5,17.4c0,1.1-0.9,2-2,2h-12c-1.1,0-2-0.9-2-2v-12c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2 V17.4L39.5,17.4z"
})));

var SvgSiteMap = function SvgSiteMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sitemap_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SiteMap.b502ec9f.svg";
export { ForwardRef as ReactComponent };